export enum IGymNotificationType {
  gym_subscription = "gym_subscription",
  ANNOUNCMENTS = "ANNOUNCMENTS",
}

export enum IGymNotificationEvent {
  ANNOUNCMENT_CREATED = "ANNOUNCMENT_CREATED",
  created = "created",
  canceled = "canceled",
  expired = "expired",
}
